import {ENDPOINT_PROGRAM} from 'common/endpoints';
import {commonJwtHeader, removeEmptyIds} from 'common/utils';

const getProgramDetails = (token, params) => {
  return fetch(
    `${ENDPOINT_PROGRAM}${
      params && params !== '' ? `?programIds=${removeEmptyIds(params)}` : ``
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getProgramById = (token, id) => {
  return fetch(`${ENDPOINT_PROGRAM}${id}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getProgramsByStatus = (status) => {
  return fetch(`${ENDPOINT_PROGRAM}?status=${status}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getProgramsbyIds = (token, programIds) => {
  return fetch(
    `${ENDPOINT_PROGRAM}${
      programIds && programIds !== '' ? `?programIds=${removeEmptyIds(programIds)}` : ``
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getAllPrograms = () => {
  return fetch(`${ENDPOINT_PROGRAM}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getProgramDetails,
  getProgramById,
  getProgramsByStatus,
  getProgramsbyIds,
  getAllPrograms,
};
